import { cn } from "@/lib/utils";

/**
 * Single source of truth for the TIS brand mark. Used on login, signup,
 * the admin/platform sidebar and anywhere the product's own identity is
 * shown (NOT a tenant's uploaded logo — that is BrandingPreview/Logo).
 * The asset lives at public/brand/tis-logo.png so it is served statically
 * and cached by the browser.
 *
 * Props:
 *   size      - "sm" | "md" | "lg" (mark height); default "md"
 *   withWordmark - render the asset only (it already contains the "TIS"
 *                  wordmark), so this just controls optional label text
 *   label     - optional text shown beside the mark (e.g. "Tenant", used
 *               in the sidebar to disambiguate the portal)
 *   onDark    - when true, use the light label color for dark backgrounds
 */
const SIZES = { sm: "h-7", md: "h-9", lg: "h-12" };

export default function BrandLogo({ size = "md", label = null, onDark = false, className = "" }) {
  return (
    <div className={cn("flex items-center gap-2.5", className)} data-testid="brand-logo">
      <img
        src="/brand/tis-logo.png"
        alt="TIS"
        className={cn(SIZES[size] || SIZES.md, "w-auto object-contain")}
        draggable={false}
      />
      {label && (
        <span
          className={cn(
            "font-heading text-lg font-semibold tracking-tight",
            onDark ? "text-white/90" : "text-foreground",
          )}
        >
          {label}
        </span>
      )}
    </div>
  );
}
